import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createProductCategory, deleteErrorProductCategory, findAllProductCategorysPageable, updateProductCategory, deleteProductCategory } from '../../actions/productCategory';
import ModalForAddProductCategory from '../ProductCategory/ModalForAddProductCategory';
import { HeaderTable } from '../../enums/ProductCategoryEnums';
import { TableContainer } from '../Reusable/TableContainer';
import ProductCategoryTable from '../ProductCategory/ProductCategoryTable';

const ProductCategoryContainer = () => {
  const dispatch = useDispatch();
  const productCategoryReducer = useSelector((state) => state.productCategory);

  const [show, setShow] = useState(false);

  const showModal = () => {
    setShow(true);
  };

  const clearValidationErrors = () => {
    dispatch(deleteErrorProductCategory());
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleAdd = (role) => {
    dispatch(createProductCategory(productCategory, handlePreviewClose));
  };

  return (
    <>
      <TableContainer
        cardTitle={HeaderTable.titleForProductCategoryTable}
        showModal={showModal}
      >
        <ProductCategoryTable
          dispatch={dispatch}
          productCategoryReducer={productCategoryReducer}
          findAllProductCategorysPageable={findAllProductCategorysPageable}
          updateProductCategory={updateProductCategory}
          deleteProductCategory={deleteProductCategory}
          clearValidationErrors={clearValidationErrors}
        />
      </TableContainer>
      {show && (
        <ModalForAddProductCategory
          productCategoryReducer={productCategoryReducer}
          handleAdd={handleAdd}
          handleClose={handlePreviewClose}
          show={show}
        />
      )}
    </>
  );
};

export default ProductCategoryContainer;